<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/sms/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش قالب پیامکی</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea color="black" v-model="sms.content" label="متن قالب پیامکی"></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-autocomplete @change="getClasses" multiple :items="schools" item-text="label" item-value="id"
                            label="آموزشگاه های مورد نظر را انتخاب کنید." v-model="sms.school_ids"></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete multiple :items="classes" item-text="title" item-value="id"
                            label="کلاس های مورد نظر را انتخاب کنید." v-model="sms.class_ids"></v-autocomplete>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "SmsEditView",
  data() {
    return {
      uploadFileDialog: false,
      schools: [],
      classes: [],
      sms: {
        status: null,
        content: null,
        school_ids: [],
        class_ids:[]
      }
    }
  },
  mounted() {
    this.getSms()
    this.getSchools()
  },
  methods: {
    buildQueryString(params) {
      return Object.keys(params)
          .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
          .join('&');
    },
    update() {
      window.axios.post('message/sms/update/' + this.$route.params.id, {
        content: this.sms.content,
        status: this.sms.status,
        school_ids: this.sms.school_ids,
        class_ids: this.sms.class_ids,
      }).then((res) => {
        this.openSnackbar(res.data.message, 'success')
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getSms() {
      window.axios.get('message/sms/get/' + this.$route.params.id).then((res) => {
        this.sms = res.data.data
        this.getClasses()
      })
    },
    getSchools() {
      window.axios.get('/school/admin-index?per_page=1000').then((res) => {
        this.schools = res.data.data
      })
    },
    getClasses() {
      let params = {
        school_ids: this.sms.school_ids.join()
      };
      window.axios.get(`/class/crud/index?${this.buildQueryString(params)}&per_page=1000`).then((res) => {
        this.classes = res.data.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>